const defaultColor = "palegreen"
function Title({title, color=defaultColor}){
    const sidePadding = color === defaultColor ? "" : "px-5";
    const smallSize = color === defaultColor ? "10" : "8";
    return (
        <div className={`container my-4 container-wide bg-${color} box-shadow`} id="title">
            <div className={`row justify-content-center align-items-center py-4 ${sidePadding}`}>
                <div className={`col-12 col-sm-${smallSize}`}>
                    <h1 className={`display-5 fw-bold text-body-emphasis lh-2 mt-0 mb-1 lh-base text-center text-sm-start quint bg-${color}`}>
                        {color === defaultColor ? 
                            <>{title}</> : 
                            <>Gyógyszer&nbsp;vagy {title}?</>}
                    </h1>
                </div>
                {
                    color !== defaultColor &&
                    <div className="col-10 col-sm-2">
                        <img
                            className="d-block mx-auto mt-4 mt-sm-0 round-img box-shadow"
                            src={process.env.PUBLIC_URL + "/images/logo_circle.png"}
                            alt="logo"
                            height={150}
                            width={150}
                        />
                    </div>
                }
            </div>
        </div>
    );
}

export default Title;